import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { EffectsModule } from '@ngrx/effects';
import { NzIconModule } from 'ng-zorro-antd/icon';

import { AvatarModule } from '@libs/src/avatar/avatar.module';
import { ProgressStepsModule } from '@libs/src/progress-steps/progress-steps.module';
import { GroupIntroSelectionsFormModule } from '@main-client/src/app/group-intro-selections-form/group-intro-selections-form.module';

import { FeedEffects } from '@main-client/src/app/feed/feed-effects.service';
import { GroupIntroSelectionsFormService } from '@main-client/src/app/group-intro-selections-form/group-intro-selections-form.service';

import { UserOnboardingViewIntroGoalsSelectionComponent } from './user-onboarding-view-intro-goals-selection.component';

@NgModule({
  declarations: [UserOnboardingViewIntroGoalsSelectionComponent],
  imports: [
    AvatarModule,
    CommonModule,
    EffectsModule.forFeature([FeedEffects]),
    FlexLayoutModule,
    GroupIntroSelectionsFormModule,
    MatButtonModule,
    MatProgressBarModule,
    NzIconModule,
    ProgressStepsModule,
  ],
  exports: [UserOnboardingViewIntroGoalsSelectionComponent],
  providers: [GroupIntroSelectionsFormService],
})
export class UserOnboardingViewIntroGoalsSelectionModule {}
